<template>
  <div class="input-group">
    <select
      :value="filterOperator"
      class="form-select"
      style="max-width: 120px"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <div class="form-check form-switch" style="flex: 1; padding-left: 40px;">
      <input
        type="checkbox"
        :checked="displayValue === true"
        :id="computedFieldId"
        class="form-check-input bg-primary border-primary"
        :disabled="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
        @change="onFilterValueChange($event.target.checked)"
      />
      <label :for="computedFieldId" class="form-check-label">
        {{ displayValue === true ? "YES" : "NO" }}
      </label>
    </div>
  </div>
</template>

<script>
import { coerceBooleanFilterValue } from "@/utils/coerceBooleanFilterValue";

export default {
  name: "FilterFieldBoolean",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [Boolean, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined) {
        const coerced = coerceBooleanFilterValue(this.value);
        if (typeof coerced === "boolean") return coerced;
        return this.value;
      }
      return false;
    },
    computedFieldId() {
      return this.fieldId || `filter-boolean-${this.field.key}`;
    },
  },
  methods: {
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
}
</style>

